import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";

function Mcgie() {
  const cellStyle = {
    borderBottomColor: "black",
    borderBottomStyle: "solid",
    borderBottomWidth: 1,
  };
  const cellComplementStyle = {
    borderLeftStyle: "solid",
    borderLeftColor: "black",
    borderLeftWidth: 1,
  };
  return (
    <TableContainer
      sx={{
        borderWidth: 1,
        borderStyle: "solid",
        borderRadius: 1,
        marginY: 2,
      }}
    >
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell sx={cellStyle} align="center">
              <strong>MÓDULO</strong>
            </TableCell>
            <TableCell sx={cellStyle} align="center">
              <strong>CÁTEDRA</strong>
            </TableCell>
            <TableCell sx={cellStyle} align="center">
              <strong>DOCENTE</strong>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell
              sx={{
                ...cellStyle,
                borderRightStyle: "solid",
                borderRightColor: "black",
                borderRightWidth: 1,
              }}
              align="center"
              rowSpan={3}
            >
              <strong>GERENCIA EMPRESARIAL</strong>
            </TableCell>
            <TableCell sx={cellStyle}>
              Dirección Estratégica y Sistemas Coorporativos
            </TableCell>
            <TableCell
              sx={{
                ...cellStyle,
                ...cellComplementStyle,
              }}
            >
              Ph. D. Ludwing Ernesto Torres Carrasco
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={cellStyle}>
              Metodología de la Investigación Científica
            </TableCell>
            <TableCell
              sx={{
                ...cellStyle,
                ...cellComplementStyle,
              }}
            >
              Ph.D. Ing. Alvaro Ives Valverde Garnica
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={cellStyle}>
              Organización Empresarial y Escenarios de Competitividad
            </TableCell>
            <TableCell
              sx={{
                ...cellStyle,
                ...cellComplementStyle,
              }}
            >
              Ph.D. Alfredo Eduardo Mancilla Heredia
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell
              sx={{
                ...cellStyle,
                borderRightStyle: "solid",
                borderRightColor: "black",
                borderRightWidth: 1,
              }}
              align="center"
              rowSpan={3}
            >
              <strong>INVESTIGACIÓN CIENTÍFICA Y DESARROLLO TECNOLÓGICO</strong>
            </TableCell>
            <TableCell sx={cellStyle}>
              Métodos Cuantitativos para la Investigación Científica y
              Tecnológica
            </TableCell>
            <TableCell
              sx={{
                ...cellStyle,
                ...cellComplementStyle,
              }}
            >
              Ph.D. Ing. Sergio Humberto Diaz Martinez
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={cellStyle}>
              Gestión de la Investigación Tecnológica
            </TableCell>
            <TableCell
              sx={{
                ...cellStyle,
                ...cellComplementStyle,
              }}
            >
              Ph. D. Lic. Cecilia Karina Curi Borda
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={cellStyle}>
              Marketing Industrial de Servicios
            </TableCell>
            <TableCell
              sx={{
                ...cellStyle,
                ...cellComplementStyle,
              }}
            >
              Lic. MBA. Lexin Ramel Arandia Saravia
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell
              sx={{
                ...cellStyle,
                borderRightStyle: "solid",
                borderRightColor: "black",
                borderRightWidth: 1,
              }}
              align="center"
              rowSpan={3}
            >
              <strong>GESTIÓN DE RECURSOS HUMANOS</strong>
            </TableCell>
            <TableCell sx={cellStyle}>
              Tecnología de Gestión del Factor Humano
            </TableCell>
            <TableCell
              sx={{
                ...cellStyle,
                ...cellComplementStyle,
              }}
            >
              Ph. D. Lic. Ligia Fátima Roxana Olivarez Rodriguez
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={cellStyle}>Ergonomía organizativa</TableCell>
            <TableCell
              sx={{
                ...cellStyle,
                ...cellComplementStyle,
              }}
            >
              Ing. M.Sc. Carla Lizett Kaune Sarabia
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={cellStyle}>
              Enfoque de Competencia en la Gestión de Recursos Humanos
            </TableCell>
            <TableCell
              sx={{
                ...cellStyle,
                ...cellComplementStyle,
              }}
            >
              Lic. MBA. Sonia Carola Arevalo Deheza
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={cellStyle} align="center" colSpan={2}>
              <strong>SEMINARIO DE INVESTIGACIÓN I</strong>
            </TableCell>
            <TableCell
              sx={{
                ...cellStyle,
                ...cellComplementStyle,
              }}
            >
              Ing. M.Sc. Juan Pablo Fernandez Rocha
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell
              sx={{
                ...cellStyle,
                borderRightStyle: "solid",
                borderRightColor: "black",
                borderRightWidth: 1,
              }}
              align="center"
              rowSpan={3}
            >
              <strong>GESTIÓN DE PRODUCCIÓN</strong>
            </TableCell>
            <TableCell sx={cellStyle}>Sistemas de Producción</TableCell>
            <TableCell
              sx={{
                ...cellStyle,
                ...cellComplementStyle,
              }}
            >
              Ing. M.Sc. Oscar Saul Olivares Quintana
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={cellStyle}>
              Gestión Logística, Optimización y Estrategias del
              Aprovisionamiento y la Distribución
            </TableCell>
            <TableCell
              sx={{
                ...cellStyle,
                ...cellComplementStyle,
              }}
            >
              Ing. M.Sc. Yuri Roberto Zamorano Braun
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={cellStyle}>Administración Financiera</TableCell>
            <TableCell
              sx={{
                ...cellStyle,
                ...cellComplementStyle,
              }}
            >
              Ing. MBA. Freddy Jaime Vargas Chocala
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell
              sx={{
                ...cellStyle,
                borderRightStyle: "solid",
                borderRightColor: "black",
                borderRightWidth: 1,
              }}
              align="center"
              rowSpan={4}
            >
              <strong>GESTIÓN INTEGRADA</strong>
            </TableCell>
            <TableCell sx={cellStyle}>Gestión de Calidad</TableCell>
            <TableCell
              sx={{
                ...cellStyle,
                ...cellComplementStyle,
              }}
            >
              Ing. M.Sc. Vigberto Frank Cespedes Saavedra
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={cellStyle}>Gestión Ambiental</TableCell>
            <TableCell sx={{ ...cellStyle, ...cellComplementStyle }}>
              Dra. Ing. Tania Angela Teran Mita
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={cellStyle}>
              Gestión de Seguridad y Salud Ocupacional y la Norma ISO 45001
            </TableCell>
            <TableCell sx={{ ...cellStyle, ...cellComplementStyle }}>
              Ph.D. Ing. Ahmed Ernesto Amusquivar Caballero
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={cellStyle}>
              Auditorías Integradas, Certificación y Acreditación
            </TableCell>
            <TableCell sx={{ ...cellStyle, ...cellComplementStyle }}>
              Ing. M.Sc. Martha Mendez Leclere
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={cellStyle} align="center" colSpan={2}>
              <strong>SEMINARIO DE INVESTIGACIÓN II</strong>
            </TableCell>
            <TableCell sx={{ ...cellStyle, ...cellComplementStyle }}>
              Ing. MBA. Ricardo Rodrigo Soliz Bonilla
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="center" colSpan={2}>
              <strong>SEMINARIO DE INVESTIGACIÓN III</strong>
            </TableCell>
            <TableCell sx={{ ...cellStyle, ...cellComplementStyle }}>
              Ph D. Ing. Jose Salomon Nuñez
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default Mcgie;
